import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/applet-appId',
  name: 'appletAppId',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/applet-appId',
      component: () => import('@/views/operation/applet-appId/index.vue'),
      meta: {
        title: '小程序密钥管理',
        icon: 'wechat'
      }
    }
  ]
}
